import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Fetch the top-performing broadcasts (sorted by CTR descending) so admins
 * can see which messaging hooks actually move users.
 */
export function useAdminTopPerformers({ enabled, limit = 5 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API}/notifications/broadcasts/top?limit=${limit}`,
        { withCredentials: true }
      );
      setItems(res.data?.items || []);
    } catch (err) {
      if (err.response?.status !== 403) {
        console.error('top performers fetch failed', err);
      }
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    if (enabled) refresh();
  }, [enabled, refresh]);

  return { items, loading, refresh };
}
